import React from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/Button";
import { Header } from "@/components/Header";
import { Icon } from "@/components/Icon";
import { Text } from "@/components/Text";
import { Flex, IDialogModal, inDialogModal } from "@/eworkitComponents";
import { CloseButton } from "@/views/components/CloseButton";
import { StyledModal } from "@/views/components/Modal";

interface IModalProps extends IDialogModal {
  error: string;
}

const Modal: React.FC<IModalProps> = ({ onClose, error }) => {
  const { t } = useTranslation("public");

  return (
    <StyledModal>
      <Flex direction="column" padding={["lg"]} innerMargin="lg">
        <Flex justify="space-between">
          <Header size="md" color="black" weight="bold">
            {t("SESSION_LOGIN.ERROR_MODAL.HEADER")}
          </Header>
          <CloseButton onClick={onClose} testName="close" />
        </Flex>
        <Flex justify="center">
          <Icon icon="warning-2" size="xxxl" color="error" />
        </Flex>
        <Flex direction="column" innerMargin="lg">
          <Text align="center">{error}</Text>
          <Flex justify="flex-end" innerMargin="md">
            <Button onClick={onClose} size="lg" testName="delete">
              <Flex padding={[false, "md"]}>
                <Text size="lg">{t("SESSION_LOGIN.ERROR_MODAL.BUTTON")}</Text>
              </Flex>
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </StyledModal>
  );
};

export const ErrorModal = inDialogModal(Modal);
